import { IconNames } from '@shipengine/giger-theme';
import { Typography, Icon } from '@shipengine/giger';
import { useTranslation } from '@packlink/translation-provider';
import { getServiceInfoStyles, getServiceInfoItemStyles, getServiceInfoItemTextStyles } from './ServiceInfoStyles.js';
import { jsx, jsxs } from '@emotion/react/jsx-runtime';

const ServiceInfo = _ref => {
  let {
    serviceInfo
  } = _ref;
  const {
    t
  } = useTranslation();
  return jsx("ul", {
    css: getServiceInfoStyles,
    children: serviceInfo.map((_ref2, index) => {
      let {
        key,
        icon
      } = _ref2;
      const label = t(key);
      return jsx(Typography, {
        variant: "small",
        css: getServiceInfoItemStyles(index === 0),
        children: jsxs("li", {
          "aria-label": label,
          title: label,
          children: [jsx(Icon, {
            name: IconNames[icon.toUpperCase().replace('-', '_')]
          }), jsx("span", {
            css: getServiceInfoItemTextStyles,
            children: label
          })]
        })
      }, index);
    })
  });
};

export { ServiceInfo };
//# sourceMappingURL=ServiceInfo.js.map
